/* eslint-disable import/no-duplicates */
import { useMemo } from 'react';
// import HomeSVG from '../icons/home.svg';
import HomeSVG from '../components/home/icons/home.svg';
import CourseSVG from '../components/home/icons/course.svg';
import Course1SVG from '../components/home/icons/course.svg';
// import TestsSVG from '../components/home/icons/tests.svg';
import ProfileSVG from '../components/home/icons/profile.svg';

import HomeFillSVG from '../components/home/icons/homefillSvg.svg';
import CourseFillSVG from '../components/home/icons/courseFill.svg';
// import TestsFillSVG from '../components/home/icons/testsFill.svg';
import ProfileFillSVG from '../components/home/icons/profileFill.svg';
// import HandOutsSVG from '../components/home/icons/handouts.svg';
import BookmarksSVG from '../components/home/icons/bookmark_fill.svg';
// import MenuArrowSVG from '../components/home/icons/menu-arrow.svg';
// import LogoutSVG from '../components/home/icons/logout.svg';
import CourseFill1SVG from '../components/home/icons/courseFill.svg';
// import HandOutsFillSVG from '../components/home/icons/handoutsFill.svg';
import BookmarksFillSVG from '../components/home/icons/bookmark_fillnew.svg';
import FreeInitiativesSVG from '../components/home/icons/FreeInitiatives.svg';
import FreeInitiativeFillSVG from '../components/home/icons/offer_fill.svg';
import CurrentAffairsSVG from '../components/home/icons/currentAffairs.svg';
import CurrentAffairsFillSVG from '../components/home/icons/news_fill.svg';
import LibrarySvg from '../components/home/icons/librarySvg.svg';
import LibraryFillSvg from '../components/home/icons/library_fill.svg';

const useMenu = (user) => {
  const localMenus = [
    {
      label: 'Home', icon: HomeSVG, iconFill: HomeFillSVG, visibility: true,
    },
    {
      label: 'Learn', icon: CourseSVG, iconFill: CourseFillSVG, visibility: user?.paidAccess?.hasPaidCourses,
    },
    {
      label: 'Courses 1.0', icon: Course1SVG, iconFill: CourseFill1SVG, visibility: user?.isPaidLegacy,
    },
    // {
    //   label: 'My Handouts', icon: HandOutsSVG, iconFill: HandOutsFillSVG, visibility: user?.isPaidLegacy,
    // },
    // {
    //   label: 'My Tests', icon: TestsSVG, iconFill: TestsFillSVG, visibility: user?.isPaidLegacy || user?.paidAccess?.isPaid,
    // },
    {
      label: 'Bookmarks', icon: BookmarksSVG, iconFill: BookmarksFillSVG, visibility: false,
    },
    {
      label: 'Free Initiatives', icon: FreeInitiativesSVG, iconFill: FreeInitiativeFillSVG, visibility: true,
    },
    {
      label: 'Current Affairs', icon: CurrentAffairsSVG, iconFill: CurrentAffairsFillSVG, visibility: true,
    },
    {
      label: 'Library', icon: LibrarySvg, iconFill: LibraryFillSvg, visibility: true,
    },
    {
      label: 'Profile', icon: ProfileSVG, iconFill: ProfileFillSVG, visibility: user?.profile?.accountDetails?.userId,
    },
  ];
  return useMemo(() => localMenus.filter((menu) => menu.visibility), [user]);

  //   const filteredMenus = useMemo(() => localMenus.filter(menu => menu.visibility), [localMenus]);

//   return localMenus;
};

export default useMenu;
